import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  to: string;
  text?: string;
}

const BackButton = ({ to, text = 'Back' }: BackButtonProps) => {
  return (
    <Button
      variant="outline"
      className="mb-6 transform hover:scale-105 transition-all duration-200"
      asChild
    >
      <Link to={to}>
        <ArrowLeft className="h-4 w-4 mr-2" />
        {text}
      </Link>
    </Button>
  );
};

export default BackButton; 